$(window).resize(function () {
    if (window.innerWidth != width) {
        //console.log('width has changed');
    }

    height = $(window).height();
    width = window.innerWidth;

    if (typeof projectChapters != "undefined" && projectChapters != null) {
        projectChapters.forEach((chapter) => {
            chapter.style.height = height + "px";
        });
    }
});
